import dayjs from "dayjs";

const utc = require("dayjs/plugin/utc"); // Import UTC plugin
const timezone = require("dayjs/plugin/timezone"); // Import timezone plugin

dayjs.extend(utc); // Enable UTC plugin
dayjs.extend(timezone); // Enable timezone plugin

export const COMPARISON_PERIOD = "period";
export const COMPARISON_DATE = "date";
export const COMPARISON_WEEKDAY = "weekday";
export const COMPARISON_CUSTOM = "custom";

export const calculateDaysBetween = (from, to) => {
  const dateFrom = dayjs(from);
  const dateTo = dayjs(to);

  return dateFrom.diff(dateTo, "day") * -1;
};

// Returns the comparison range for a given range + mode.
// - period:  the equally long period directly before (today -> yesterday,
//            a full week -> the previous week, ...)
// - date:    exactly one year back (same calendar dates)
// - weekday: exactly 52 weeks (364 days) back => identical weekday alignment
// - custom:  the user-picked range (calendar button); falls back to "period"
//            if no custom range is set (e.g. stale persisted state)
export const getComparisonRange = (range, mode, customRange) => {
  const parse = (dateStr) => dayjs(dateStr).tz("Europe/Berlin", true);

  if (mode === COMPARISON_CUSTOM && customRange?.min && customRange?.max) {
    return {
      min: parse(customRange.min).startOf("day").format(),
      max: parse(customRange.max).endOf("day").format(),
    };
  }

  let min = parse(range.min);
  let max = parse(range.max);

  if (mode === COMPARISON_WEEKDAY) {
    min = min.subtract(52, "week");
    max = max.subtract(52, "week");
  } else if (mode === COMPARISON_PERIOD) {
    // Inclusive number of days in the range (single day => 1).
    const days = calculateDaysBetween(range.min, range.max) + 1;
    min = min.subtract(days, "day");
    max = max.subtract(days, "day");
  } else {
    min = min.subtract(1, "year");
    max = max.subtract(1, "year");
  }

  return {
    min: min.startOf("day").format(),
    max: max.endOf("day").format(),
  };
};

// Aggregates the headline totals across all shops of a statistic object.
export const getStatisticTotals = (statistic) => {
  const shops = statistic?.shops || [];
  // AI-API-Kosten sind keinem Shop zugeordnet — fließen als eigener
  // Posten in Kosten und Gewinn ein
  const aiCosts = statistic?.aiCosts?.total || 0;

  const totals = shops.reduce(
    (totals, shop) => {
      const costs = Object.keys(shop.costs || {}).reduce(
        (sum, key) => sum + (shop.costs[key] || 0),
        0
      );
      const revenue = shop.revenue?.total || 0;

      totals.orders += shop.totalOrders || 0;
      totals.revenue += revenue;
      totals.costs += costs;
      totals.profit += revenue - costs;

      return totals;
    },
    { orders: 0, revenue: 0, costs: 0, profit: 0 }
  );

  totals.costs += aiCosts;
  totals.profit -= aiCosts;
  return totals;
};
